import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${colors.white};
    border-radius: ${pxToRem(12)};
    width: ${pxToRem(141)};
    height: ${pxToRem(104)};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3),
      0px 1px 3px 1px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  `,
  title: css`
    font-size: 16px;
    font-weight: bold;
    font-family: 'Proxima Nova Bold', Arial, Helvetica, sans-serif;
  `,
  variants: {
    new: css`
      color: ${colors.jungle} !important;
    `,
    upcoming: css`
      color: ${colors.orange} !important;
    `,
    all: css`
      color: ${colors.slate} !important;
    `,
  },
  amount: css`
    font-family: 'Proxima Nova Bold', Arial, Helvetica, sans-serif;
    color: ${colors.prussian};
    font-size: 25px;
    font-weight: bold;
  `,
  frequency: css`
    font-size: ${pxToRem(12)};
    color: ${colors.slate};
  `,
};

export default styles;
